export default __webpack_public_path__ + "assets/models/e974d536ad728239e5749e86a8a6d977.glb";